"use client";
import Paging from "@/components/common/paging/Paging";
import { DEFAULT_PAGE, NEXT_PAGE_NUMBER } from "@/constants/appConstant";
import Link from "next/link";
import { getPostsByTopicUrlName } from "../api/post/postAPI";
import React, { useEffect, useState } from "react";
import Breadcrumbs from "@/components/common/BreadCrumb";
import { usePathname } from "next/navigation";
import { Skeleton } from "primereact/skeleton";
import OptimizedImage from '@/components/common/optimizedImage/OptimizedImage';
import PageHeader from "@/components/common/page-header";

const ShareExperiencePosts = () => {
    const [posts, setPosts] = useState([]);
    const [currentPage, setCurrentPage] = useState(DEFAULT_PAGE);
    const [hasNext, setHasNext] = useState(true);
    const [totalElements, setTotalElements] = useState(0);

    const pathname = usePathname();
    const urlName = `/${pathname.split("/")[1]}`;

    useEffect(() => {
        const fetchPosts = async () => {
            const response = await getPostsByTopicUrlName(urlName, currentPage);
            const newPosts = response?.data?.data?.content || [];

            setPosts(prev => {
                const merged = [...prev, ...newPosts];
                const uniqueMap = new Map();
                merged.forEach((item, index) => {
                    const safeKey =
                        item?.id ||
                        item?.slug ||
                        item?.urlName ||
                        `post-${index}`;

                    if (!uniqueMap.has(safeKey)) {
                        uniqueMap.set(safeKey, item);
                    }
                });

                return Array.from(uniqueMap.values());
            });

            setHasNext(response?.data?.data?.hasNext);
            setTotalElements(response?.data?.data?.totalElements);
        };

        fetchPosts();
    }, [urlName, currentPage]);

    const handleLoadMore = () => {
        setCurrentPage(prev => prev + NEXT_PAGE_NUMBER);
    };

    const paths = [
        { name: "TRANG CHỦ", url: "/" },
        { name: "GÓC CHIA SẺ KINH NGHIỆM" }
    ];

    return (
        <>
            <PageHeader title="Góc chia sẻ kinh nghiệm" />


            <div className="container-fluid" style={{ marginTop: "20px" }}>
                <Breadcrumbs paths={paths} />
            </div>

            <hr className="w-full border-t-2 border-gray-600" />

            {posts.length === 0 ? (
                <div className="container-fluid block-content mb-0 mt-7">
                    <div className="row main-grid flex justify-content-center">
                        <div className="col-sm-9">
                            <div className="tab-content row services">
                                <div className="tab-pane active">
                                    {[1, 2, 3].map(i => (
                                        <div
                                            key={`skeleton-${i}`}
                                            className="service-item col-xs-12 col-sm-4 isotope-item allservices seafreight railway mb-7"
                                        >
                                            <Skeleton width="360px" height="270px" />
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="container-fluid block-content mb-0 mt-7">
                    <div className="row main-grid flex justify-content-center">
                        <div className="col-sm-9">
                            <div className="row services">

                                {posts.map((post, index) => {
                                    const safeKey =
                                        post?.id ||
                                        post?.slug ||
                                        post?.urlName ||
                                        `post-${currentPage}-${index}`;

                                    const cleanImage =
                                        post?.titleImage?.replace(/^"+|"+$/g, "") ||
                                        "/img/no-image.png";

                                    return (
                                        <div
                                            key={safeKey}
                                            className="service-item col-xs-12 col-sm-4 isotope-item allservices seafreight railway wow zoomIn mb-0"
                                            data-wow-delay="0.3s"
                                        >
                                            <div className="img-service">
                                                <Link href={post.urlName}>
                                                    <OptimizedImage
                                                        src={post.titleImage}
                                                        alt={post.name}
                                                        width={360}
                                                        height={270}
                                                        className="full-width"
                                                        priority={index < 6}
                                                        sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 33vw"
                                                    />
                                                </Link>
                                            </div>

                                            <Link className="no-underline" href={post.urlName}>
                                                <h4 className="name-post">{post.name}</h4>
                                            </Link>

                                            <p className="description-post">{post.description}</p>

                                            <div className="text-center">
                                                <Link
                                                    className="btn btn-brand m-3 align-items-center"
                                                    href={post.urlName}
                                                >
                                                    Chi tiết
                                                </Link>
                                            </div>
                                        </div>
                                    );
                                })}

                                <Paging
                                    onLoadMore={handleLoadMore}
                                    totalElements={totalElements}
                                    hasNext={hasNext}
                                    data={posts}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default ShareExperiencePosts;
